// extracted by mini-css-extract-plugin
module.exports = {"loader":"Loader_loader__2Elt2","is-loading":"Loader_is-loading__21_fM","rotating":"Loader_rotating__2pYHV"};